import { render } from "./trust-data-main.html?vue&type=template&id=06112896&scoped=true&ts=true&external"
import script from "./trust-data-main.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-main.ts?vue&type=script&lang=ts&external"

import "./trust-data-main.scss?vue&type=style&index=0&id=06112896&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06112896"]])

export default __exports__